export { AddPipe } from './add.pipe';
export { CalendarPipe } from './calendar.pipe';
export { DateFormatPipe } from './date-format.pipe';
export { DifferencePipe } from './difference.pipe';
export { DurationPipe } from './duration.pipe';
export { FromUnixPipe } from './from-unix.pipe';
export { ParsePipe } from './parse.pipe';
export { MomentModule } from './moment.module';
export { SubtractPipe } from './subtract.pipe';
export { TimeAgoPipe } from './time-ago.pipe';
export { UtcPipe } from './utc.pipe';
export { FromUtcPipe } from './from-utc.pipe';
export { LocalTimePipe } from './local.pipe';
export { LocalePipe } from './locale.pipe';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// index.ts